import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { PAYMENT_METHOD_PATH } from '../../../../config/paths';
import {
  clearPaymentMethod,
  getPaymentMethod,
  putPaymentMethod,
} from '../../../../actions';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import PaymentMethodForm from './PaymentMethodForm';
import { TRANSACTION_CODE } from '../../../../config/constants';

const EditPaymentMethod = ({
  breadcrumbs,
  dispatchGetPaymentMethod,
  dispatchClearPaymentMethod,
  dispatchPutPaymentMethod,
  match: {
    params: { id: paymentMethodId },
  },
  loading,
  paymentMethod,
}) => {
  useLayoutEffect(() => {
    dispatchGetPaymentMethod({ paymentMethodId });

    return () => dispatchClearPaymentMethod();
  }, []);

  const onSubmit = (formValues) =>
    dispatchPutPaymentMethod(paymentMethodId, {
      ...formValues,
    });

  const generateInitialValues = ({
    name,
    description,
    transactionCode
  }) => ({
    name,
    description,
    transactionCode: TRANSACTION_CODE[transactionCode]
  });

  let content;

  if (loading) content = <Loader />;
  else if (paymentMethod.isEmpty())
    content = <NoDataResource returnPage={PAYMENT_METHOD_PATH} />;
  else
    content = (
      <PaymentMethodForm
        onSubmit={onSubmit}
        initialValues={generateInitialValues(paymentMethod.toJS())}
      />
    );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Editar Método de Pago"
      subtitle="Editar método de pago"
      content={content}
    />
  );
};

EditPaymentMethod.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearPaymentMethod: PropTypes.func.isRequired,
  dispatchGetPaymentMethod: PropTypes.func.isRequired,
  dispatchPutPaymentMethod: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  paymentMethod: PropTypes.instanceOf(Immutable.Map).isRequired,
};

EditPaymentMethod.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearPaymentMethod: clearPaymentMethod,
  dispatchGetPaymentMethod: getPaymentMethod,
  dispatchPutPaymentMethod: putPaymentMethod,
};

const mapStateToProps = (
  { AccountingUnit },
  {
    match: {
      params: { id },
    },
  },
) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Métodos de Pago',
      href: PAYMENT_METHOD_PATH,
    },
    {
      text: 'Ver',
      href: `${PAYMENT_METHOD_PATH}/${id}`,
    },
    {
      text: 'Editar',
      href: '',
    },
  ],
  paymentMethod: AccountingUnit.PaymentMethod.getIn(['current', 'content']),
  loading: !AccountingUnit.PaymentMethod.getIn(['current', 'activity']).isEmpty(),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditPaymentMethod);
